import BookmarksIcon from './assets/sidebarIcons/Bookmarks.png'
import Players from './assets/sidebarIcons/Players.png';
import Clubs from './assets/sidebarIcons/Clubs.png';
import Search from './assets/sidebarIcons/searchIcon.png';
import Chemistry from './pages/Chemistry';
import { IRoute } from './types/ISidebarListItem';
import LogoutComponent from './components/Logout'
import PlayerSearchInitiate from './pages/Players/PlayerSearchInitiate';
import logoutIcon from './assets/icons/logout.png';
import SortListComponent from './pages/Shortlists/index';
import ClubSearchInitiate from './pages/Clubs/ClubSearchInitiate';
import HomeIcon from './assets/sidebarIcons/HomeIconGrey.svg';
import SettingIcon from './assets/sidebarIcons/Settings.png';

const routes: IRoute[] = [
    { path: '/home', name: 'Home', icon: HomeIcon, component: Chemistry, Id: 'Home', shouldNavigate: true },
    { path: '/search', name: 'Search', icon: Search, component: 'GlobalSearch', Id: 'Search', shouldNavigate: false, subNav: true },
    { path: '/playersearch', name: 'Create player list', icon: Players, component: PlayerSearchInitiate, Id: 'PlayersSearch', shouldNavigate: false },
    { path: '/clubsearch', name: 'Create club list', icon: Clubs, component: ClubSearchInitiate, Id: 'Clubs', shouldNavigate: false, },
    { path: '/shortlists', name: 'Shortlists', icon: BookmarksIcon, component: SortListComponent, Id: 'Shortlists', shouldNavigate: false },
    { path: '/changepassword', name: 'Change Password', icon: SettingIcon, component: "ChangePassword", Id: 'ChangePassword', shouldNavigate: true },
    { path: '/logout', name: 'Logout', icon: logoutIcon, component: LogoutComponent, Id: 'Logout', shouldNavigate: true },
];

export default routes;
